// extracted by mini-css-extract-plugin
export var text = "_3b-0";